export default __webpack_public_path__ + "static/media/Mr. Aira Kharvel Parida.2349358c.png";